/**
 * --------------------------------------------------------------------------
 * Basic Modules: ProductEdit.js
 * --------------------------------------------------------------------------
 */

//import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = true;
const NAME              = 'productEdit';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
    product_url: '/index.php/dashboard/store/products/edit/{$PRODUCT_ID}'
};

const Event = {
    CLICK               : `click${EVENT_KEY}`,
};

const Selector = {
    TOGGLE              : '[data-toggle-product-edit]',
};

class ProductEdit {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this._element = element;
        this._config  = this._getConfig(config);

        this._addEventListeners();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _addEventListeners() {
        $(this._element).on(Event.CLICK, (event) => this._goToProductEdit(event));
    }

    /**
     * Handle the resizing of the window
     * @private
     */
    _goToProductEdit(event) {

        event.preventDefault();
        console.log('CLICKED');

        let product_id = parseInt($(this._element).attr('data-product-id'));

        if (product_id > 0) {
            let target = this._config.product_url.replace('{$PRODUCT_ID}', product_id);
            window.location.href = target;
        }
        else {
            console.log('Error retrieving product id');
        }
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        ProductEdit._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new ProductEdit(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = ProductEdit._jQueryInterface;
$.fn[NAME].Constructor = ProductEdit;


export default ProductEdit;
